// lineItems/rendererResolver.js
import { renderMnhItems } from "./renderers/mnh.renderer";
import { renderManaswiniItems } from "./renderers/manaswini.renderer";
import { ORG_CODES } from "../../../shared/constants";
import { renderVedamaayuItems } from "./renderers/vedamaayu.renderer";

export const getLineItemRenderer = (orgCode) => {
  console.log("getLineItemRenderer : ", orgCode);
  switch (orgCode) {
    case ORG_CODES.MNH:
      return renderMnhItems;
    case ORG_CODES.MANASWINI:
      return renderManaswiniItems;
    case ORG_CODES.VEDAMAAYU:
      return renderVedamaayuItems;
    default:
      return renderVedamaayuItems;
  }
};
